export default __webpack_public_path__ + "static/media/pagePhoto8.6ef64c0f.png";